import React, { useEffect, useState } from "react";
import "./confirmation-modal.css";
import { Modal } from "../ModalComponent/Modal";
import { SetLocalSetting } from "../../../utils/genericUtils";

const defaultProps = {
  id: "id",
  isActive: false,
  header: "header",
  message: "message",
  headerFontSize: 25,
  messageFontSize: 15,
  icon: undefined,
  iconLeft: false,
  textAlign: "left",
  showDivider: true,
  animate: true,
  animationTime: 500,
  bg_opacity: 0.5,
  height: undefined,
  width: undefined,
  includeCheckboxSafety: true,
  safetyText: "Warning...",
  includeDontAskAgain: false,
  dontAskText : 'Dont ask again',
  dontAskSetting: "",
  confirmText: "Yes",
  confirmClass: "",
  useDeny: true,
  denyText: "Nevermind",
  denyClass: "",
  onDeny: () => {},
  onConfirm: () => {},
  onClickOut: () => {},
};

export function ConfirmationModal(props = defaultProps) {
  const [safetyAcknowledged, setSafetyAcknowledged] = useState(false);
  const [dontAskAgain, setDontAskAgain] = useState(false);

  function safetyCheck(event) {
    let input = event.target;
    let button = document.querySelector("#" + props.id + "-confirm-button");
    if (input.checked) {
      button.disabled = false;
      setSafetyAcknowledged(true);
    } else {
      button.disabled = true;
    }
  }

  function onDontAskAgain(event) {
    let input = event.target;
    if (input.checked) {
      setDontAskAgain(true);
    } else {
      setDontAskAgain(false);
    }
  }

  function onConfirm() {
    SetLocalSetting(props.dontAskSetting, !dontAskAgain);
    props.onConfirm();
  }

  return (
    <Modal {...props} class="confirmation-modal">
      {props.includeCheckboxSafety ? (
        <div className="safety-checkbox-area">
          <label htmlFor={props.id + "-safety"} className="warning-text">
            {props.safetyText}
          </label>
          <input
            id={props.id + "-safety"}
            onChange={(e) => {
              safetyCheck(e);
            }}
            name={props.id + "-safety"}
            type="checkbox"
          />
        </div>
      ) : null}

      {props.includeDontAskAgain ? (
        <>
          <div className="safety-checkbox-area">
            <label htmlFor={props.id + "-dont-ask-again"} className="warning-text">
              {props.dontAskText ? props.dontAskText : `Don't ask again`}
            </label>
            <input
              id={props.id + "-dont-ask-again"}
              onChange={(e) => {
                onDontAskAgain(e);
              }}
              name={props.id + "-dont-ask-again"}
              type="checkbox"
            />
          </div>
        </>
      ) : null}

      <div className="confirmation-modal-buttons" style={{ marginTop: !props.includeCheckboxSafety ? "35px" : 0 }}>
        {(props.useDeny  === undefined || props.useDeny === true) && (
          <button className={["standard-button deny-btn", props.denyClass ?? ""].join(" ")} onClick={props.onDeny}>
            {props.denyText}
          </button>
        )}
        <button
          id={props.id + "-confirm-button"}
          disabled={props.includeCheckboxSafety && !safetyAcknowledged}
          className={["standard-button confirm-btn", props.confirmClass ?? ""].join(" ")}
          onClick={onConfirm}
        >
          {props.confirmText}
        </button>
      </div>
    </Modal>
  );
}
